angular.module('tgaAdmin')
  .service('domainService', ['$http', '$location', 'envService',
    function ($http, $location, envService) {
      const serverAddress = envService.read('serverAddress');
      const forceDomain = envService.read('forceDomain');
      const host = $location.host();
      let base = host;
      let domain = null;
      let permissionsPromise = null;
      let permissions = {};

      if (host.indexOf('.') >= 2) {
        const parts = host.split('.');
        domain = parts.shift();
        base = parts.join('.');
      }

      if (forceDomain) {
        domain = forceDomain;
      }

      function destroy() {
        permissionsPromise = null;
      }

      function getDomain(domainId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}domain`,
          params: {
            domain,
            domain_id: domainId,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getDomains() {
        return $http({
          method: 'GET',
          url: `${serverAddress}domain/all`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateDomain(data) {
        data.domain = data.name || domain;

        return $http({
          method: 'PUT',
          url: `${serverAddress}domain`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getDomainSettings(domainId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}settings`,
          params: {
            domain_id: domainId,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateDomainSettings(data) {
        return $http({
          method: 'PUT',
          url: `${serverAddress}domain/settings`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateSso(data) {
        data.domain = domain;

        return $http({
          method: 'PUT',
          url: `${serverAddress}domain/sso`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function checkDomain(d) {
        return $http({
          method: 'POST',
          url: `${serverAddress}domain/check`,
          data: {
            domain: d,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getPermissions() {
        if (!permissionsPromise) {
          permissionsPromise = $http({
            method: 'GET',
            url: `${serverAddress}domain/permissions`,
            params: {
              domain,
            },
          }).then(
            (response) => {
              permissions = response.data;
              return permissions;
            },
            (error) => {
              throw error.data;
            },
          );
        }

        return permissionsPromise;
      }

      function hasPermission(group, name) {
        if (permissions[group]) {
          for (let i = 0; i < permissions[group].length; i++) {
            if (permissions[group][i] === name) {
              return true;
            }
          }
        }

        return false;
      }

      function getSubscription() {
        return $http({
          method: 'GET',
          url: `${serverAddress}domain/subscription`,
          params: {
            domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getSubscriptions() {
        return $http({
          method: 'GET',
          url: `${serverAddress}domain/subscriptions`,
          params: {
            domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getSoonestExpiration() {
        return getSubscriptions().then(
          // eslint-disable-next-line consistent-return
          (subscriptions) => {
            if (subscriptions.length) {
              const expirationDates = [];
              for (let i = 0; i < subscriptions.length; i++) {
                expirationDates.push(subscriptions[i].date_expires);
              }
              const orderedDates = expirationDates.sort((a, b) => Date.parse(b) - Date.parse(a));

              const diff = moment(orderedDates[0]).diff(moment(), 'milliseconds');
              const whenExpired = moment(orderedDates[0]).fromNow();
              const duration = moment.duration(diff);

              return {
                minutes: duration.asMinutes(),
                whenExpired,
              };
            }
          },
        );
      }

      function checkExpiration() {
        return getSubscriptions().then(
          (subscriptions) => {
            if (subscriptions.length) {
              for (let i = 0; i < subscriptions.length; i++) {
                if (moment(subscriptions[i].date_expires).utc().isAfter()) {
                  return false;
                }
              }
            }
            return true;
          },
        );
      }

      function checkSSO() {
        return $http({
          method: 'GET',
          url: `${serverAddress}domain/sso`,
          params: {
            domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getDomainStats(currentDomain) {
        let params;
        if (currentDomain === true) {
          params = {
            domain,
          };
        } else if (currentDomain) {
          params = {
            domain: currentDomain,
          };
        }

        return $http({
          method: 'GET',
          url: `${serverAddress}domain/stats`,
          params,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getDomainNotes(domainId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}domain/note/${domainId}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function addDomainNote(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}domain/note`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getUserDomainsHavingGameType(gametype) {
        return $http({
          method: 'GET',
          url: `${serverAddress}domain/usergame`,
          params: {
            game_type: gametype,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getUserDomainsHavingArcades() {
        return $http({
          method: 'GET',
          url: `${serverAddress}domain/userarcades`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function addSuperAdminAccessLog(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}domain/log_sa_access`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function enableAIFeatures(data) {
        return $http({
          method: 'PUT',
          url: `${serverAddress}domain/ai_access`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function isDomainLoggingRequired(user, targetDomain) {
        const { user_type } = user;
        const userTypesRequiringLogging = ['super_admin', 'sales_admin', 'support_admin', 'creator_admin', 'viewer_admin'];
        // these are always our domains and don't require a reason to access
        const domainDoesNotRequireLogging = ['tga', 'tga-qa'].includes(targetDomain);
        // need to perform domain logging if user type is included in the list above and is trying to reach client domain
        const userRequiresLogging = userTypesRequiringLogging.indexOf(user_type) !== -1;
        return userRequiresLogging && !domainDoesNotRequireLogging;
      }

      return ({
        api: serverAddress,
        base,
        domain,
        destroy,
        getDomain,
        updateDomain,
        getDomainSettings,
        updateDomainSettings,
        updateSso,
        checkDomain,
        getPermissions,
        hasPermission,
        getSubscription,
        getSubscriptions,
        checkSSO,
        getSoonestExpiration,
        checkExpiration,
        getDomainStats,
        getDomainNotes,
        addDomainNote,
        getUserDomainsHavingGameType,
        getUserDomainsHavingArcades,
        addSuperAdminAccessLog,
        enableAIFeatures,
        isDomainLoggingRequired,
        getDomains,
      });
    },
  ]);
